import { TASKS } from '@/contexts/ability/tasks';

import type { TaskRequirement } from './types';

export const CASH_POOLING_MEMBER = -TASKS.CASH_POOLING;

/** The top tasks of a backend module: every task of the module descends from one, so holding any opens it. */
export const BACKEND_MODULE = {
  FORECAST: [TASKS.FORECAST, TASKS.ACCOUNTS_HISTORY_1700],
  PAYMENTS_RECEIPT: [TASKS.PAYMENTS_RECEIPT],
  LINK: [TASKS.LINKS],
  CURRENCY_RATES: [TASKS.CURRENCY],
} satisfies Record<string, TaskRequirement>;

/**
 * The `@RequiresTask` of each endpoint the widgets and the overview read, copied
 * from the named controllers: any one task of a gate opens it.
 */
export const GATE = {
  /** `/analytic-overview/*`: AnalyticOverviewController */
  analyticOverview: [TASKS.OVERVIEW_ANALYTIC],
  /** `/strategic-overview/*`: StrategicOverviewController */
  strategicOverview: [TASKS.OVERVIEW_STRATEGIC],
  /** `/strategic-overview/indicators`: StrategicOverviewController */
  strategicIndicators: [TASKS.OVERVIEW_STRATEGIC, TASKS.ACCOUNTS_HISTORY_1700],
  /** `/balances/summary/*`: BalanceSummaryController */
  balanceSummary: [TASKS.CASH_POSITION, TASKS.OVERVIEW],
  /** `/cash-position/accounts` and `/groups`: CashPositionController */
  cashAccounts: [TASKS.CASH_POSITION, TASKS.FORECAST, TASKS.ACCOUNTS_HISTORY_1700],
  /** `/cash-position/summary` and `/strategic`: CashPositionController */
  cashSummary: [TASKS.CASH_POSITION],
  /** `/cash-position/history/*`: HistoryCashPositionController */
  cashHistory: [TASKS.CASH_POSITION, TASKS.ACCOUNTS_HISTORY_1700],
  /** `/cash-position/forecasts/*`: ForecastCashPositionController */
  cashForecast: [TASKS.CASH_POSITION, TASKS.FORECAST],
  /** `/cash-flows` and `/cashflow-views`: CashFlowController, CashFlowViewController */
  cashFlows: [TASKS.CASH_FLOW],
  /** `/investment-overview/*` and `/investments/movements`: InvestmentOverviewController, InvestmentController */
  investments: [TASKS.INVESTMENT],
  /** `/debts/overview` and `/liabilities/portfolio-snapshot`: DebtController, LiabilityPortfolioSnapshotController */
  debts: [TASKS.DEBT],
  /** `/transactions`: TransactionController */
  transactions: [TASKS.TRANSACTIONS],
  /** `/payments`: PaymentController */
  payments: [TASKS.PAYMENTS],
  /** `/pix-transactions`: PixTransactionController */
  pix: [TASKS.PIX],
  /** `/payment-slips`: PaymentSlipController */
  paymentSlips: [TASKS.PAYMENT_SLIPS],
  /** `/cash-pooling/insights` and `/rule-executions`: CashPoolingClientController, CashPoolingRuleExecutionController */
  cashPooling: [TASKS.CASH_POOLING],
  /** `/bank-transfers/certificates` and `/market-status`: BankTransferController */
  bankTransfers: [TASKS.CASH_POOLING],
  cashPoolingMember: [CASH_POOLING_MEMBER],
  /** `/financial-closing/*` and `/statements/*`: FinancialClosingController, MonthlyStatementController */
  financialClosing: [TASKS.FINANCIAL_CLOSING, TASKS.BANK_STATEMENT],
  /** `/period-statement-executions`: PeriodStatementExecutionController */
  periodStatements: [TASKS.PERIOD_STATEMENT_EXECUTION],
  /** `/tariffs/*`: TariffController, TariffsAnalyticsController */
  tariffs: [TASKS.TARIFFS],
  /** `/policies/*` and `/institution-ratings/*`: PolicyController, InstitutionRatingController */
  policies: [TASKS.POLICY],
  /** `/report-executions`, `/report-schedules`, `/favourite-reports`: Report*Controller, FavouriteReportController */
  reports: [TASKS.REPORTS],
  /** `GET /links/schedules`: SyncScheduleController */
  linkSchedules: [TASKS.LINKS],
  /** `/notifications`: NotificationController */
  notifications: [TASKS.NOTIFICATIONS],
} satisfies Record<string, TaskRequirement>;
